import { Stack } from "@mui/material";
import { useState } from "react";

export function ScrollableContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  const [hasScrolled, setHasScrolled] = useState(false);
  return (
    <Stack
      sx={{
        position: "relative",
        left: "-24px",
        width: "calc(100% + 48px)",
        overflowX: "visible",
      }}
    >
      <Stack
        sx={{
          width: "100%",
          overflowX: "scroll",
          ...(hasScrolled
            ? {}
            : {
                scrollbarColor: "transparent transparent",
              }),
        }}
        onScroll={(e) => setHasScrolled(true)}
      >
        {children}
      </Stack>
    </Stack>
  );
}
